export const AppConstant = {
  localStorage: {
    userId: "userId",
    selectedDate: "selectedDate",
    teamId: "teamId",
    companyName: "companyName",
    tenantId: "tenantId",
    memberDetail: "memberDetail",
    emailList: "emailList",
    toTime: "toTime",
    fromtime: "fromTime",
    duration: "duration",
    bookingDate: "bookingDate",
    hostEmaild: "hostEmailid",
    meeting: "meeting",
    token: "token",
    vegitoken: "vegitoken",
    bookingId: "bookingId",
    claId: 'claId',
    isAdmin: 'isAdmin',
    userDetails: 'userDetails',
    emailId: "emailId",
    subject: "subject",
    body: "body",
    fromId: 'fromId',
    status: "",
    bookedBy: "user",
    createdBy: "",
    locationId: null,
    totalCreditConsumed: "totalCreditConsumed",
    changeHour: "changeHour",
    changeMinute: "changeMinute",
    changeamorpm: "changeamorpm",
    selectedHost: "selectedHost",
    claAdminId: "claAdminId",
    selectedMember: "selectedMember",
    creditId: "creditId",
    creditCompanyName: "creditCompanyName",
    creditCompanyAddress: "creditCompanyAddress",
    userType: "userType",
    parkId: "parkId",
  },
}
